module.exports = "<app-login></app-login>"


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_welcome/combine/combine.component.html
// module id = ../../../../../src/app/_components/components_welcome/combine/combine.component.html
// module chunks = main